import { RichTextEditor } from "../RichTextEditor/RichTextEditor";

export const EmailComposerBody = (props: {
  value: string | undefined;
  onChange: (value: string | undefined) => void;
  bodyHeight?: string;
}) => {
  return <RichTextEditor value={props.value} onChange={(value) => props.onChange(value)} height={props.bodyHeight} />;
};
